module.exports = "/assets/wrf04-temperature-sensor-configuration-left.png";